import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
export class SingleServiceVehicleStore {
    constructor(serviceVehicleService) {
        this.serviceVehicleService = serviceVehicleService;
        this.vehicle = null;
        this.loading = false;
        makeAutoObservable(this);
    }
    setVehicle(vehicle) {
        this.vehicle = vehicle;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async init(vehicleId) {
        this.setLoading(true);
        try {
            const vehicles = vehicleId
                ? await this.serviceVehicleService.getVehiclesByIds([vehicleId])
                : null;
            this.setVehicle(vehicles?.[0] || null);
        }
        catch (error) {
            onError(error, "Error initializing service vehicle");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveVehicle(vehicleData) {
        try {
            this.setLoading(true);
            let result;
            if (this.vehicle) {
                result = await this.serviceVehicleService.updateVehicle(this.vehicle.id, vehicleData);
            }
            else {
                result = await this.serviceVehicleService.createVehicle(vehicleData);
            }
            this.setVehicle(result);
            return result;
        }
        catch (error) {
            onError(error, "Error saving service vehicle");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteVehicle(vehicleId) {
        try {
            this.setLoading(true);
            await this.serviceVehicleService.deleteVehicle(vehicleId);
        }
        catch (error) {
            onError(error, "Error deleting service vehicle");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearVehicleData() {
        this.setVehicle(null);
    }
}
